import logo from "./logo.svg";
import "./App.css";
import AnimatedRoutes from "./component/AnimatedRoutes";
import { BrowserRouter } from "react-router-dom";
import Alumni from "./pages/Alumni";
import { LoaderProvider } from "./utils/LoaderUtils";
import ScrollToTop from "./utils/ScrollToTopUtils";
import { ToastContainer } from "react-toastify";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import PageLoader from "./context/PageLoader";
import { Suspense } from "react";

function App() {
  return (
    <>
      <SiteConfigProvider>
        <LoaderProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<PageLoader />}>
              <AnimatedRoutes />
            </Suspense>
          </BrowserRouter>
        </LoaderProvider>
      </SiteConfigProvider>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
